<template>
  <div class="detail-page">
    <div class="noshow"></div>
    <div class="container">
      <title-div
        class="title-content"
        :title="$t('contracts.detail.name')"
        :data="$route.params.contractHash"
      ></title-div>

      <div v-if="contract.list" class="detail-content">
        <div class="item-content">
          <div class="item double-b">
            <item1-div
              :title="$t('all.name')"
              :singledata="contract.list.name"
              :logo="contract.list.logo ? contract.list.logo : 'nologo'"
            >
              <span class="desc-content">
                {{ contract.list.description }}
              </span>
            </item1-div>
          </div>
        </div>

        <div class="content-bar">
          <div class="content-col">
            <div class="content-hd">
              {{ $t("tokens.detail.tokenOverview") }}
            </div>

            <div class="item-content">
              <div class="m-item">
                <item-div
                  :tooltipstr="$t('tooltip.contract.volume')"
                  :title="$t('tokens.detail.volume')"
                  :singledata="
                    $HelperTools.toFinancialVal(
                      parseInt(contract.list.ont_sum)
                    ) +
                      ' ONT,  ' +
                      $HelperTools.toFinancialVal(contract.list.ong_sum) +
                      ' ONG'
                  "
                ></item-div>
              </div>
            </div>
            <div class="item-content">
              <div class="m-item">
                <item-div
                  :tooltipstr="$t('tooltip.contract.addressesamount')"
                  :title="$t('contracts.list.tab.addressCount')"
                  :singledata="
                    $HelperTools.toFinancialVal(contract.list.address_count)
                  "
                ></item-div>
              </div>
            </div>
            <div class="item-content">
              <div class="m-item">
                <item-div
                  :tooltipstr="$t('tooltip.contract.txamount')"
                  :title="$t('tokens.detail.txn')"
                  :singledata="
                    $HelperTools.toFinancialVal(contract.list.tx_count)
                  "
                ></item-div>
              </div>
            </div>
          </div>
          <div class="content-col">
            <div class="content-hd">{{ $t("tokens.detail.tokenProfile") }}</div>
            <div class="item-content">
              <div class="m-item">
                <item-div
                  tooltipstr=""
                  :title="$t('tokens.detail.address')"
                  :token="contract.list"
                  copyable
                ></item-div>
              </div>
            </div>
            <div class="item-content">
              <div class="item">
                <item-div
                  :tooltipstr="$t('tooltip.contract.creater')"
                  :title="$t('contracts.detail.creator')"
                  :address="contract.list.creator"
                ></item-div>
              </div>
            </div>
            <div class="item-content">
              <div class="item">
                <item-div
                  :tooltipstr="$t('tooltip.contract.createdTime')"
                  :title="$t('contracts.detail.createdTime')"
                  :singledata="
                    $HelperTools.getTransDate(contract.list.create_time)
                  "
                ></item-div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--更明显的展示方式，后期开放-->
      <!--<detail-block-2 :name1="$t('contracts.detail.ontFlow')" :val1="contract.list.OntCount" :rows1="'1.1'"-->
      <!--:name2="$t('contracts.detail.ongFlow')" :val2="contract.list.OngCount" :rows2="'1.1'">-->
      <!--</detail-block-2>-->

      <!-- Tab Control -->

      <div class="tab-content">
        <div class="tabs">
          <div class="switch">
            <div
              @click="toPage('contract')"
              :class="contractFlag ? 'btn-current' : 'btn-choose'"
            >
              <div class="text">{{ $t("all.contract") }}</div>
              <div class="line"></div>
            </div>
            <div
              @click="toPage('txns')"
              :class="txnsFlag ? 'btn-current' : 'btn-choose'"
            >
              <div class="text">{{ $t("all.txns") }}</div>
              <div class="line"></div>
            </div>
            <div
              @click="toPage('code')"
              :class="codeFlag ? 'btn-current' : 'btn-choose'"
            >
              <div class="text">{{ $t("tokens.detail.code") }}</div>
              <div class="line"></div>
            </div>
            <div
              @click="toPage('abi')"
              :class="abiFlag ? 'btn-current' : 'btn-choose'"
            >
              <div class="text">{{ $t("tokens.detail.abi") }}</div>
              <div class="line"></div>
            </div>
            <div
              @click="toPage('statistics')"
              :class="statisticsFlag ? 'btn-current' : 'btn-choose'"
            >
              <div class="text">{{ $t("tokens.detail.statistic") }}</div>
              <div class="line"></div>
            </div>
            <div
              @click="toPage('analytics')"
              :class="analyticsFlag ? 'btn-current' : 'btn-choose'"
            >
              <div class="text">{{ $t("all.analytics") }}</div>
              <div class="line"></div>
            </div>
          </div>
        </div>
        <div
          v-if="analyticsFlag"
          class="tab-item-wrapper"
          v-loading="fullscreenLoading"
        >
          <div class="tab-item">
            <div class="analytics-container">
              <div class="analytics-tabs">
                <div
                  @click="turnAnalyticsTab('tx')"
                  :class="
                    analyticsType === 'tx'
                      ? 'analytics-tab-btn active'
                      : 'analytics-tab-btn'
                  "
                >
                  {{ $t("analytics.tx") }}
                </div>
                <div
                  @click="turnAnalyticsTab('oep4')"
                  :class="
                    analyticsType === 'oep4'
                      ? 'analytics-tab-btn active'
                      : 'analytics-tab-btn'
                  "
                >
                  {{ $t("analytics.token") }}
                </div>
                <div
                  @click="turnAnalyticsTab('ont')"
                  :class="
                    analyticsType === 'ont'
                      ? 'analytics-tab-btn active'
                      : 'analytics-tab-btn'
                  "
                >
                  {{ $t("analytics.ontBalance") }}
                </div>
                <div
                  @click="turnAnalyticsTab('ong')"
                  :class="
                    analyticsType === 'ong'
                      ? 'analytics-tab-btn active'
                      : 'analytics-tab-btn'
                  "
                >
                  {{ $t("analytics.ongBalance") }}
                </div>
              </div>
              <div v-if="analyticsType === 'ont'" class="analytics-item">
                <analytics-div
                  :tx_amount="AtxAmountList"
                  :tx="AtxList"
                  :deposit="AdepositList"
                  :withdraw="AwithdrawList"
                ></analytics-div>
              </div>
              <div v-if="analyticsType === 'ong'" class="analytics-item">
                <analytics-div
                  :tx_amount="AtxAmountList"
                  :tx="AtxList"
                  :deposit="AdepositList"
                  :withdraw="AwithdrawList"
                ></analytics-div>
              </div>
              <div v-if="analyticsType === 'tx'" class="analytics-item">
                <tokenanalytics-div
                  :date="AdateList"
                  :csCount="TAcsCount"
                  :txCount="TAtxCount"
                  :depositAddressCount="TAdepositAddressCount"
                  :withdrawAddressCount="TAwithdrawAddressCount"
                  :addressCount="TAaddressCount"
                ></tokenanalytics-div>
              </div>
              <div v-if="analyticsType === 'oep4'" class="analytics-item">
                <tokenanalytics-div
                  :date="AdateList"
                  :csCount="TAcsCount"
                  :txCount="TAtxCount"
                  :depositAddressCount="TAdepositAddressCount"
                  :withdrawAddressCount="TAwithdrawAddressCount"
                  :addressCount="TAaddressCount"
                ></tokenanalytics-div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="!analyticsFlag"
          class="tab-item-wrapper"
          v-loading="fullscreenLoading"
        >
          <!-- 交易列表 -->
          <div v-if="txnsFlag" class="tab-item">
            <div class="table-wrapper">
              <table class="table">
                <thead>
                  <tr>
                    <th class="text-first">{{ $t("all.hash") }}</th>
                    <th>{{ $t("all.status") }}</th>
                    <th>{{ $t("all.block") }}</th>
                    <th>{{ $t("all.fee") }}</th>
                    <th class="text-right text-last">{{ $t("all.time") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(tx, index) in contractTxList.list" :key="index">
                    <td
                      class="click-able text-first"
                      @click="toTransactionDetailPage(tx.tx_hash)"
                    >
                      {{
                        tx.tx_hash.substr(0, 8) + "..." + tx.tx_hash.substr(56)
                      }}
                    </td>
                    <td :class="tx.confirm_flag === 1 ? 'confirmed' : 'failed'">
                      {{
                        tx.confirm_flag === 1
                          ? $t("transList.confirmed")
                          : $t("transList.failed")
                      }}
                    </td>
                    <td
                      class="click-able"
                      @click="toBlockDetailPage(tx.block_height)"
                    >
                      {{ tx.block_height }}
                    </td>
                    <td>{{ Number(tx.fee).toString() }} ONG</td>
                    <td class="text-right text-last">
                      {{ $HelperTools.getTransDate(tx.tx_time) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ont-pagination
              v-if="contractTxList.total"
              :total="contractTxList.total"
            ></ont-pagination>
          </div>
          <!-- code -->
          <div v-if="codeFlag" class="tab-item">
            <source-code
              v-for="(code, index) in code_list"
              :key="code"
              :code="code"
              lang="json"
              :show-line-number="false"
              :class="{ 'mt-10': !!index }"
            />
          </div>
          <!-- abi -->
          <div v-if="abiFlag" class="tab-item">
            <source-code
              v-for="(ABI, index) in ABI_list"
              :key="ABI"
              :code="jsonBeautifier(ABI)"
              lang="json"
              :class="{ 'mt-10': !!index }"
            />
            <!-- <item1-div
              v-if="contract.list.abi"
              :jsondata="JSON.parse()"
            ></item1-div> -->
          </div>
          <div v-if="statisticsFlag" class="tab-item">
            <div class="chart-content">
              <div
                class="chart-item"
                v-for="(item, index) in statisticsData.data"
                :key="index"
              >
                <line-chart
                  v-if="hackReset"
                  class="line-chart-style"
                  :labels="statisticsData.labels"
                  :label="
                    14 + $t('statistics.day') + $t('statistics.' + item.label)
                  "
                  :data="item.list"
                  :index="index"
                ></line-chart>
              </div>
            </div>
          </div>
          <div v-if="contractFlag && contract.list" class="tab-item">
            <source-code-list :contract-info="contract.list"></source-code-list>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Clipboard from "clipboard";
import itemDiv from "../common/DetailItemH";
import item1Div from "../common/DetailItem";
import titleDiv from "../common/DetailTitle";
import analyticsDiv from "../common/contractAnalytics";
import tokenanalyticsDiv from "../common/contractTokenAnalytics";
import SourceCodeList from "./SourceCodeList.vue";
import SourceCode from "./SourceCode.vue";
const SEPARATOR = "%&#*";

export default {
  name: "Contracts-Detail",
  components: {
    itemDiv,
    item1Div,
    titleDiv,
    analyticsDiv,
    tokenanalyticsDiv,
    SourceCodeList,
    SourceCode
  },
  mounted() {
    if (
      this.$route.params.pageSize == undefined ||
      this.$route.params.pageNumber == undefined ||
      this.$route.params.contractType == undefined
    ) {
      this.toContractDetailPage(this.$route.params.contractHash);
    } else {
      this.getContractData();
      this.getStatisticsData();
    }
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
  watch: {
    $route: function() {
      if (this.$route.name == "ContractAnalytics") {
        this.txnsFlag = false;
        this.codeFlag = false;
        this.abiFlag = false;
        this.statisticsFlag = false;
        this.contractFlag = false;
        this.analyticsFlag = true;
        this.turnAnalyticsTab(this.$route.params.analyticsType);
        this.getContractdetailData();
      } else {
        this.getContractData();
        this.getStatisticsData();
      }
    },
    contract: function() {
      //  console.log(this.contract)
      if (
        this.$route.params.contractHash ==
        "cae215265a5e348bfd603b8db22893aa74b42417"
      ) {
        this.contract.list.address_count =
          this.contract.list.address_count + 32620;
        this.contract.list.total = this.contract.list.total + 63617;
        var cacuOng = parseFloat(this.contract.list.ong_sum) * 1000000000;
        var cacuOnt = parseFloat(this.contract.list.ont_sum);
        cacuOng = cacuOng + 116055.79681789 * 1000000000;
        this.contract.list.ont_sum = cacuOnt.toString();
        this.contract.list.ong_sum = (cacuOng / 1000000000).toString();
      }
    },
    contractTxList: function() {
      this.loadingFlag = true;
      this.fullscreenLoading = false;
      //  console.log(this.contractTxList)
    },
    scAnalyticsData: function() {
      let tx_amount = [];
      let dateList = [];
      let txList = [];
      let withdrawList = [];
      let depositList = [];
      let recordList = [];
      this.AtxAmountList = [];
      this.AtxList = [];
      this.AdepositList = [];
      this.AwithdrawList = [];
      if (this.scAnalyticsData) {
        recordList = this.scAnalyticsData;
      } else {
        recordList = [];
      }
      let NowTime = new Date();
      NowTime = NowTime.getTime();
      for (var i = 0; i < recordList.length; i++) {
        let time = recordList[i].date;
        time =
          time.substr(0, 4) + "/" + time.substr(4, 2) + "/" + time.substr(6, 2);
        let date = new Date(time);
        time = date.getTime();
        dateList.push(time);
        tx_amount.push([time, recordList[i].tx_amount]);
        txList.push([time, recordList[i].tx_count]);
        withdrawList.push([time, recordList[i].withdraw_addr]);
        depositList.push([time, recordList[i].deposit_addr]);
        if (i === recordList.length - 1) {
          console.log(NowTime - dateList[i]);
          if (NowTime - dateList[i] > 86400000) {
            tx_amount.push([NowTime, 0]);
            txList.push([NowTime, 0]);
            withdrawList.push([NowTime, 0]);
            depositList.push([NowTime, 0]);
          }
        }
      }
      this.AtxAmountList = tx_amount;
      this.AtxList = txList;
      this.AdepositList = depositList;
      this.AwithdrawList = withdrawList;
      this.fullscreenLoading = false;
    },
    scTokenAnalyticsData: function() {
      let tx = [];
      let sc = [];
      let address = [];
      let withdrawaddress = [];
      let depositaddress = [];
      let dateList = [];
      let recordList = [];
      if (this.scTokenAnalyticsData) {
        recordList = this.scTokenAnalyticsData;
      } else {
        recordList = [];
      }
      let NowTime = new Date();
      NowTime = NowTime.getTime();
      for (var i = 0; i < recordList.length; i++) {
        let time = recordList[i].date;
        time =
          time.substr(0, 4) + "/" + time.substr(4, 2) + "/" + time.substr(6, 2);
        let date = new Date(time);
        time = date.getTime();
        dateList.push(time);
        tx.push([time, recordList[i].tx_count]);
        sc.push([time, recordList[i].contract_count]);
        address.push([time, recordList[i].tx_addr]);
        withdrawaddress.push([time, recordList[i].withdraw_addr]);
        depositaddress.push([time, recordList[i].deposit_addr]);
        if (i === recordList.length - 1) {
          console.log(NowTime - dateList[i]);
          if (NowTime - dateList[i] > 86400000) {
            tx.push([NowTime, 0]);
            sc.push([NowTime, 0]);
            address.push([NowTime, 0]);
            withdrawaddress.push([NowTime, 0]);
            depositaddress.push([NowTime, 0]);
          }
        }
      }
      this.TAcsCount = sc;
      this.TAtxCount = tx;
      this.TAdepositAddressCount = depositaddress;
      this.TAwithdrawAddressCount = withdrawaddress;
      this.TAaddressCount = address;
      this.fullscreenLoading = false;
    }
  },
  computed: {
    ...mapState({
      contract: state => state.Contracts.Detail,
      contractTxList: state => state.Contracts.TxList,
      statisticsData: state => state.Statistics.StatisticsData,
      scAnalyticsData: state => state.Analytics.scAnalytics.info,
      scTokenAnalyticsData: state => state.Analytics.scTokenAnalytics.info
    }),
    ABI_list() {
      const abi = this.contract.list.abi;
      if (!abi) {
        return [];
      }
      return abi.split(SEPARATOR).filter(item => !!item && item !== "null");
    },
    code_list() {
      const code = this.contract.list.code;
      if (!code) {
        return [];
      }
      return code.split(SEPARATOR).filter(item => !!item && item !== "null");
    },
    isEtherContract() {
      const hash = this.$route.params.contractHash;
      if (
        hash.slice(0, 2) === "0x" &&
        this.$HelperTools.isHexString(hash.slice(-40))
      ) {
        return true;
      }
      return false;
    }
  },
  data() {
    return {
      showCodeCopied: false,
      showABICopied: false,
      hackReset: false,
      loadingFlag: false,
      fullscreenLoading: true,
      txnsFlag: false,
      codeFlag: false,
      abiFlag: false,
      statisticsFlag: false,
      analyticsFlag: false,
      contractFlag: true,
      aOntFlag: false,
      aOngFlag: false,
      aOep4Flag: false,
      AtxAmountList: [],
      AongBList: [],
      AdateList: [],
      AtxList: [],
      AdepositList: [],
      AwithdrawList: [],
      TAcsCount: [],
      TAtxCount: [],
      TAdepositTxCount: [],
      TAwithdrawTxCount: [],
      TAdepositAddressCount: [],
      TAwithdrawAddressCount: [],
      TAaddressCount: [],
      analyticsType: "tx"
    };
  },
  methods: {
    toPage($val) {
      if ($val == "txns") {
        this.analyticsFlag = false;
        this.txnsFlag = true;
        this.codeFlag = false;
        this.abiFlag = false;
        this.statisticsFlag = false;
        this.contractFlag = false;
      }
      if ($val == "code") {
        this.txnsFlag = false;
        this.analyticsFlag = false;
        this.codeFlag = true;
        this.abiFlag = false;
        this.statisticsFlag = false;
        this.contractFlag = false;
      }
      if ($val == "abi") {
        this.txnsFlag = false;
        this.codeFlag = false;
        this.analyticsFlag = false;
        this.abiFlag = true;
        this.statisticsFlag = false;
        this.contractFlag = false;
      }
      if ($val == "statistics") {
        this.txnsFlag = false;
        this.codeFlag = false;
        this.abiFlag = false;
        this.analyticsFlag = false;
        this.statisticsFlag = true;
        this.contractFlag = false;
      }
      if ($val == "analytics") {
        this.txnsFlag = false;
        this.codeFlag = false;
        this.abiFlag = false;
        this.statisticsFlag = false;
        this.contractFlag = false;
        this.analyticsFlag = true;
        this.getAddressAnalyticsData();
      }
      if ($val == "contract") {
        this.txnsFlag = false;
        this.codeFlag = false;
        this.abiFlag = false;
        this.statisticsFlag = false;
        this.contractFlag = true;
        this.analyticsFlag = false;
      }
    },
    turnAnalyticsTab($type) {
      this.analyticsType = $type;
      this.getAddressAnalyticsData();
    },
    getAddressAnalyticsData() {
      /*       this.AtxAmountList = []
      this.AongBList = []
      this.AdateList= []
      this.AtxList= []
      this.AdepositList= []
      this.AwithdrawList= []
      this.TAcsCount=[]
      this.TAtxCount=[]
      this.TAdepositTxCount=[]
      this.TAwithdrawTxCount=[]
      this.TAdepositAddressCount=[]
      this.TAwithdrawAddressCount=[]
      this.TAaddressCount=[] */
      var params = this.$route.params;
      params.analyticsType = this.analyticsType;
      this.fullscreenLoading = true;
      if (params.analyticsType !== "oep4" && params.analyticsType !== "tx") {
        this.$store
          .dispatch("getscAnalytics", params)
          .finally(() => (this.fullscreenLoading = false));
      } else {
        if (params.analyticsType === "oep4" && this.isEtherContract) {
          params.analyticsType = "orc20";
        }
        this.$store
          .dispatch("getscTokenAnalytics", params)
          .finally(() => (this.fullscreenLoading = false));
      }
    },
    turnTo(scVal) {
      if (scVal.substr(0, 4) != "http") {
        window.open("http://" + scVal);
      } else {
        window.open(scVal);
      }
    },
    async getContractData() {
      this.contract.list = "";
      this.fullscreenLoading = true;
      if (this.$route.params.contractType == undefined) {
        this.$route.params.contractType = "all";
      }
      await this.$store.dispatch("GetContract", this.$route.params);
      await this.$store.dispatch("GetContractTx", this.$route.params);
      this.fullscreenLoading = false;
    },
    getContractdetailData() {
      this.contract.list = "";
      this.fullscreenLoading = true;
      if (this.$route.params.contractType == undefined) {
        this.$route.params.contractType = "all";
      }
      this.$store
        .dispatch("GetContract", this.$route.params)
        .finally(() => (this.fullscreenLoading = false));
    },
    toTransactionDetailPage($TxnId) {
      if (this.$route.params.net == undefined) {
        this.$router.push({
          name: "TransactionDetail",
          params: { tx_hash: $TxnId }
        });
      } else {
        this.$router.push({
          name: "TransactionDetailTest",
          params: { tx_hash: $TxnId, net: "testnet" }
        });
      }
    },
    toContractDetailPage($hash) {
      if (this.$route.params.net === "testnet") {
        this.$router.push({
          name: "ContractDetailTest",
          params: {
            contractType: "all",
            contractHash: $hash,
            pageSize: 10,
            pageNumber: 1,
            net: "testnet"
          }
        });
      } else {
        this.$router.push({
          name: "ContractDetail",
          params: {
            contractType: "all",
            contractHash: $hash,
            pageSize: 10,
            pageNumber: 1
          }
        });
      }
    },
    toBlockDetailPage($blockHeight) {
      if (this.$route.params.net == undefined) {
        this.$router.push({
          name: "blockDetail",
          params: { param: $blockHeight }
        });
      } else {
        this.$router.push({
          name: "blockDetailTest",
          params: { param: $blockHeight, net: "testnet" }
        });
      }
    },
    toTransDetailPage($TxnId) {
      if (this.$route.params.net === "testnet") {
        this.$router.push({
          name: "TransactionDetailTest",
          params: { tx_hash: $TxnId, net: "testnet" }
        });
      } else {
        this.$router.push({
          name: "TransactionDetail",
          params: { tx_hash: $TxnId }
        });
      }
    },
    copyDetailVal($id) {
      let clipboard = new Clipboard(".copy-success");

      clipboard.on("success", function(e) {
        e.clearSelection();
      });

      if ($id === "scCodeData") {
        this.showCodeCopied = true;
      } else {
        this.showABICopied = true;
      }
    },
    getStatisticsData() {
      this.statisticsData.data = "";

      this.hackReset = false;
      this.$nextTick(() => {
        this.hackReset = true;
      });

      this.$store.dispatch("getStatisticsData", this.$route.params).then();
    },
    jsonBeautifier(json) {
      try {
        return JSON.stringify(JSON.parse(json), null, 2);
      } catch (error) {
        return json;
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/detail-page.less";
</style>
<style>
.el-loading-spinner .path {
  stroke: #000;
}
</style>

<style lang="less" scoped>
.desc-content {
  margin-left: 50px;
  margin-top: -3px;
  font-size: 14px;
  font-family: Avenir-Book, Avenir;
  color: #000000;
  line-height: 19px;
  flex: 1;
}

.title-content {
  align-self: center;
}

.content-bar {
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
}
.content-col {
  width: 540px;
}
.content-hd {
  margin-bottom: 40px;
  font-size: 18px;
  font-family: Avenir-Heavy, Avenir;
  font-weight: 800;
  color: #000000;
  line-height: 25px;

  > span {
    font-size: 12px;
    opacity: 0.6;
    margin-left: 10px;
    font-weight: 300;
  }
}

.mt-10 {
  margin-top: 10px;
}

@media only screen and (max-width: 960px) {
  .content-col {
    flex-basis: 100%;
  }
  .desc-content {
    flex: initial;
    margin-left: 0;
    margin-top: 20px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contract/Detail.vue